export default __webpack_public_path__ + "static/media/tunak-tunak-tun.gif";